export const themeJson = {
  "themeName": "layered",
  "colorPalette": "light",
  "isPanelless": false,
  "backgroundImage": "",
  "backgroundOpacity": 1,
  "backgroundImageAttachment": "scroll",
  "backgroundImageFit": "cover",
  "cssVariables": {
    /* -- GEOMETRY -- */
    "--sjs-corner-radius": "12px",
    "--sjs-base-unit": "8px",

    /* -- SHADOWS -- */
    "--sjs-shadow-small": "0px 1px 2px 0px rgba(0, 0, 0, 0.1)",
    "--sjs-shadow-medium": "0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs-shadow-large": "0px 8px 16px 0px rgba(0, 0, 0, 0.1)",
    "--sjs-shadow-inner": "inset 0px 1px 2px 0px rgba(0, 0, 0, 0.05)",

    /* -- BORDERS -- */
    "--sjs-border-default": "#D0D0D0",
    "--sjs-border-light": "#E0E0E0",
    "--sjs-border-inside": "#E0E0E0",

    /* -- BACKGROUNDS -- */
    "--sjs-general-backcolor": "#F4F4F4",
    "--sjs-general-backcolor-dark": "#EAEAEA",

    /* -- INPUT FIELDS -- */
    "--sjs-editor-background": "#F9F9F9",
    "--sjs-editorpanel-backcolor": "#F9F9F9",
    "--sjs-editorpanel-hovercolor": "#F0F0F0",

    /* -- QUESTION CARD -- */
    "--sjs-questionpanel-backcolor": "#FFFFFF",
    "--sjs-questionpanel-hovercolor": "#FFFFFF",

    /* -- TEXT & PLACEHOLDERS (FIXED) -- */
    /* Основной текст - почти черный */
    "--sjs-general-forecolor": "#111111",

    /* Placeholder и второстепенный текст - явно серый */
    "--sjs-general-forecolor-light": "#8C8C8C",

    /* Дополнительные градации */
    "--sjs-general-dim-forecolor": "#222222",
    "--sjs-general-dim-forecolor-light": "#8C8C8C",

    /* -- PRIMARY COLOR (BUTTONS) -- */
    "--sjs-primary-backcolor": "#FF8038",
    "--sjs-primary-backcolor-dark": "#E66A20",
    "--sjs-primary-backcolor-light": "rgba(255, 128, 56, 0.15)",
    "--sjs-primary-forecolor": "#FFFFFF",
    "--sjs-primary-forecolor-light": "rgba(255, 255, 255, 0.5)",

    /* -- SECONDARY -- */
    "--sjs-secondary-backcolor": "#404040",
    "--sjs-secondary-backcolor-light": "rgba(64, 64, 64, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(64, 64, 64, 0.25)",
    "--sjs-secondary-forecolor": "#FFFFFF",
    "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",

    /* -- FONTS -- */
    "--sjs-article-font-xx-large-fontFamily": "'Quicksand', 'Nunito', 'Varela Round', sans-serif",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontSize": "32px",
    "--sjs-article-font-xx-large-forecolor": "#FF8038",

    "--sjs-article-font-x-large-fontFamily": "'Quicksand', 'Nunito', 'Varela Round', sans-serif",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontSize": "24px",
    "--sjs-article-font-x-large-forecolor": "#111111",

    "--sjs-article-font-large-fontFamily": "'Quicksand', 'Nunito', 'Varela Round', sans-serif",
    "--sjs-article-font-large-fontWeight": "600",
    "--sjs-article-font-large-fontSize": "20px",
    "--sjs-article-font-large-forecolor": "#111111",

    "--sjs-article-font-default-fontFamily": "'Mulish', 'Manrope', 'Open Sans', sans-serif",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontSize": "16px",

    /* Reset decorations */
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",

    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",

    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",

    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",

    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",

    /* Special Colors */
    "--sjs-special-red": "#E64A19",
    "--sjs-special-red-light": "rgba(230, 74, 25, 0.1)",
    "--sjs-special-green": "#43A047",
    "--sjs-special-green-light": "rgba(67, 160, 71, 0.1)",
  },
  "header": {
    "height": 100,
    "textAreaWidth": 600,
    "inheritWidthFrom": "container"
  },
  "headerView": "advanced"
};